import type { PropsWithChildren } from "react";
import { memo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { SearchResultsTable } from "app/pages/sales-intelligence/common-components/search-results-table";

type FallbackProps = {
    isLoading?: boolean;
};

type Props = PropsWithChildren<
    FallbackProps & {
        isVisible: boolean;
    }
>;

export const TableFallback = memo(({ isLoading = true }: FallbackProps) => {
    const { translate } = useTranslate();

    return (
        <SearchResultsTable
            data={[]}
            columnConfig={[]}
            isLoading={isLoading}
            noData={{
                type: "error",
                title: translate("error.boundary.title"),
            }}
        />
    );
});

const SearchResultsTableFallback = ({ isLoading, isVisible, children }: Props) => {
    return isVisible ? <TableFallback isLoading={isLoading} /> : children;
};

export default SearchResultsTableFallback;
